import React from 'react';

const Wrapper = (Template) => {
    return ({ childElement, _innerRef, onClick, displayState }) => <Template displayState={displayState} onClick={onClick} ref={_innerRef}>
        {childElement}
    </Template>
}

export default Wrapper